var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"header-nav__item",attrs:{"role":"menuitem"}},[_c('router-link',{attrs:{"exact":_vm.exact,"to":{ name: _vm.route }}},[_vm._t("default"),_c('span',{staticClass:"label"},[_vm._t("label")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }